export function cloneObject(object) {
  return JSON.parse(JSON.stringify(object))
}
